import React from 'react'
import { Route } from 'react-router-dom'
import ChangePassword from './ChangePassword'

import { changePasswordRoot } from "../../../constants/routePaths"

const ChangePasswordRoute = [
  <Route
    key="ChangePassword"
    exact path={changePasswordRoot}
    component={ChangePassword}
  />,
];

export default ChangePasswordRoute